import { Anchor, Icon } from "@newsela/angelou";

import ContentCardV2 from "@/components/ContentCardV2";
import HorizontalScrollContainer from "@/components/HorizontalScrollContainer";
import { ContentRowProps } from "../ContentRow.interface";

import {
  contentScrollableListCss,
  defaultHeadingCss,
  headerAndDescriptionContainerCss,
  headerDescriptionCss,
  headerIconCss,
  bundleRowContainerCss,
  linkCss,
  listItemCss,
} from "./BundleContentRow.styles";

const BundleContentRow = ({
  children,
  dataQaSelector = "",
  description,
  iconSvg,
  title,
  url,
}: ContentRowProps) => {
  if (children.length === 0) {
    return null;
  }

  const contentItems = children.slice(0, 4);

  return (
    <section css={bundleRowContainerCss}>
      <div css={headerAndDescriptionContainerCss}>
        <div css={defaultHeadingCss}>
          {iconSvg ? (
            <Icon SvgComponent={iconSvg} __cssFor={{ root: headerIconCss }} />
          ) : null}
          <span>{title}</span>
          {url ? (
            <Anchor href={url} __cssFor={linkCss}>
              View more
            </Anchor>
          ) : null}
        </div>

        <div css={headerDescriptionCss}>{description}</div>
      </div>

      <HorizontalScrollContainer>
        <ul css={contentScrollableListCss}>
          {contentItems.map((content, index) => (
            <li css={listItemCss} key={index}>
              <ContentCardV2 {...content} dataQaSelector={dataQaSelector} />
            </li>
          ))}
        </ul>
      </HorizontalScrollContainer>
    </section>
  );
};

export default BundleContentRow;
